module.exports = __webpack_public_path__ + "static/img/privacy-img-left.aa0c8ee0.png";